import {Department} from '../Department';
import { Role } from '../Role';

export class LoginResponse {

  userName: string;
  email: string;
  role: Role[];
  token: string;
  name: string;
  surname: string;
  department: Department;
  employeeId: number;
  authorities: string[];
  selectedRole: Role;
  manager: boolean;
  admin: boolean;
  hr: boolean;
  version: string;
}
